__turbopack_context__.v({
  "fadeIn": "FkpSba_fadeIn",
  "fadeInText": "FkpSba_fadeInText",
  "h1": "FkpSba_h1",
  "h2": "FkpSba_h2",
  "h3": "FkpSba_h3",
  "titleH": "FkpSba_titleH",
});
